<template>
	<component :is="component.component && `${component.component}Config`" @onChangeFormData="handleFormData" :formSelect="component" :formData="formData" />
</template>

<script>
import components from "../../elements/config";

export default {
	name: "FieldProperty",
	props: ['formData'],
	components,
	computed: {
		component() {
			return this.formData.formSelect;
		},
	},
	methods: {
		handleFormData() {
			this.$emit('onChangeFormData', this.formData);
		}
	}
};
</script>